var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.seccion.Css,attrs:{"to":_vm.seccion.Href}},[(_vm.seccion.ImgUrl != '#')?_c('img',{attrs:{"src":_vm.seccion.ImgUrl}}):_vm._e(),_vm._v(" \n\t"+_vm._s(_vm.seccion.Nombre)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }